import { persistentKVStore } from '../../../infra/persistence';
var DISMISSED_KEY = 'squire_clientReferralsCtaDismissed';
export var isCtaShownForPathname = function (pathname) {
    var allowedPathnames = [{ path: /^\/appointments(?:\/.*)?$/ }];
    return allowedPathnames.some(function (_a) {
        var path = _a.path;
        return path.test(pathname);
    });
};
export var setCtaDismissedDateToNow = function () {
    persistentKVStore.setItem(DISMISSED_KEY, new Date().toISOString());
};
export var wasCtaDismissed = function () {
    var dismissedDate = persistentKVStore.getItem(DISMISSED_KEY);
    return !!dismissedDate;
};
